<template>
  <b-modal
    id="modal-tos"
    title-class="page-overlay__content-header page-overlay__content-header--no-margin"
    body-class="page-overlay__content-text page-overlay__content-text--long-text"
    scrollable
    ok-only
    ok-title="Close"
    button-size="sm"
    title="Terms of Service"
  >
    <div class="tos">
      <p class="mb-4">
        Note: This is the SAME Terms of Service you agreed to when you created
        your Pixapup account. It can be found here:
        <a href="https://pixapup.com/terms-of-service" target="_blank"
          >pixapup.com/tos</a
        >
      </p>
      <h2>
        By checking the underlying "I Agree" checkbox and submitting the
        underlying form you are agreeing to the following terms:
      </h2>

      <h3>Legal Agreement</h3>
      <p>
        By agreeing to submit without restriction your image(s) and associated
        text, herein referred to as your "Content", you are indicating your
        consent to and acceptance of the terms of this Agreement.
      </p>
      <p>
        If you do not agree with the terms of this Agreement, please do not
        submit your Content.
      </p>

      <p>
        This Agreement describes the legal relationship between you (referred to
        in this Agreement as "you" or "user") and New Media Now LLC, creator and
        owner of Pixapup.com and Pixapup web application (referred to in this
        Agreement as "we," "us" or "Company") relating to any content that you
        post, upload, or submit to us via this Pixapup web app. Please read this
        document carefully.
      </p>
      <p>
        You may submit Content provided you do so in accordance with the
        Submission Rules below. You accept entire responsibility for all Content
        that you submit to, transmit through, link through, or otherwise make
        available through us. For all Content that you submit to us, you agree
        to indemnify us as provided below.
      </p>

      <p>
        By submitting Content, you are NOT making any commitment or promise or
        obligation or representation to purchase the product before or after it
        is published and made available for sale. By including your Content in
        any of our products, we make no representation or claim or demand that
        you purchase the product ever, at any time, as a condition of your
        submitting your Content or of us having included your Content in any of
        our completed products.
      </p>

      <h3>License</h3>

      <p>
        By submitting Content, you grant us a royalty-free, perpetual,
        irrevocable, nonexclusive right and license to use, copy, modify,
        display, archive, store, distribute, reproduce, and create derivative
        works from such Content, in any form, media (print, electronic or
        otherwise), software or technology of any kind now existing or developed
        in the future.
      </p>

      <h3>Copyright Notice</h3>

      <p>
        Our published works and products, whether they include your Content or
        not, are intended for your personal use only. Other than Content that
        you submit in accordance with the terms of this Agreement, all of our
        Content, including but not limited to graphics, text, design, buttons,
        logos, images, icons, and other artwork are the sole property of Company
        or its third party Content providers, unless noted and acknowledged
        otherwise in the published work.
      </p>

      <h3>Representations and Warranties</h3>
      <p>
        By uploading or otherwise submitting any Content to us, you represent
        and warrant that:
      </p>
      <ul>
        <li>
          (a) You own or otherwise have all necessary rights, including but not
          limited to copyrights, to the Content and have the right to use it as
          provided in this Agreement;
        </li>
        <li>
          (b) All information submitted by you is true, accurate, current and
          complete, and does not violate this Agreement;
        </li>
        <li>
          (c) You have the full right, power and authority to enter into and
          perform this Agreement, and have secured all third party consents,
          licenses, waivers and permissions necessary to enter into and perform
          this Agreement, including, without limitation, waivers of rights of
          privacy, publicity and personality from any third parties whose names,
          likenesses, photographs, animated portrayals, or actual or imitated
          voices are depicted in the Content;
        </li>
        <li>
          (d) We shall not be required to make any payments with respect to the
          authorized use of any Content submitted by you, including, without
          limitation, any payments to you, third parties claiming rights through
          you or otherwise, publishers, rights agents, performance rights
          societies, persons who contributed to or whose names, likeness,
          photographs, animated portrayals or actual or imitated voices appear
          in such Content, your licensors, unions or guilds; and
        </li>
        <li>
          (e) The Content submitted by you will not:
          <ul class="mt-2">
            <li>
              (i) Infringe upon or misappropriate any rights of others,
              including, without limitation, any copyrights, trademarks, trade
              secrets or other intellectual property rights, rights of
              publicity, rights of privacy, moral rights or any other
              proprietary rights of third parties;
            </li>
            <li>
              (ii) Violate any applicable law, statute, ordinance or regulation;
            </li>
            <li>
              (iii) Be defamatory, trade libelous, trademark disparaging,
              fraudulent, harassing, abusive, threatening, harmful, lewd,
              pornographic or obscene;
            </li>
            <li>
              (iv) Disrupt, place unreasonable burdens or excessive loads on,
              interfere with or attempt to facilitate any unauthorized access to
              any portion of their computer systems, servers or networks;
            </li>
            <li>
              (v) Transmit junk mail, chain letters, or other unsolicited bulk
              e-mail, spam or duplicative messages to other users;
            </li>
            <li>
              (vi) Collect information about other users without their consent
              or otherwise systematically extract data or data fields,
              including, without limitation, any financial data or e-mail
              addresses, from our computer systems without our consent; or
            </li>

            <li>
              (vii) Contain any viruses, trojan horses, time bombs or other
              programming routines or elements that detrimentally interfere with
              computer systems or data. You agree that, upon request, you will
              provide us with evidence, in a form and format reasonably
              acceptable to us, indicating that the Content submitted by you
              complies with the foregoing warranties.
            </li>
          </ul>
        </li>
      </ul>
      <h3>Indemnity</h3>
      <p>
        You agree to indemnify and hold us harmless from and against any and all
        claims, suits, liabilities, obligations, damages, injuries, penalties,
        fines, losses, costs and expenses (including, without limitation,
        attorneys' fees) arising out of, resulting from or related to any breach
        of the foregoing representations and warranties. This obligation shall
        survive the termination of this Agreement for any reason.
      </p>

      <h3>Content Take-Down Policy</h3>
      <p>
        We cannot and do not monitor all of the material submitted to us.
        Additionally, we do not control, and are not responsible for, Content
        submitted by users.
      </p>
      <p>
        Notwithstanding the foregoing, you acknowledge that we shall have the
        right (but not the obligation) to review any Content that you have
        submitted to us, and to reject, delete, disable, or remove any Content
        that we determine, in our sole discretion, (a) does not comply with the
        terms and conditions of this Agreement; (b) might violate any law,
        infringe upon any rights of third parties, or subject us to liability
        for any reason; or (c) might adversely affect our public image,
        reputation or goodwill. Moreover, we reserve the right to reject,
        delete, disable, or remove any Content at any time, for the reasons set
        forth above, for any other reason, or for no reason.
      </p>

      <h3>Account Termination Policy</h3>

      <p>
        You may terminate your Pixapup account at any time by deleting your
        account from within the Pixapup app. If you delete your account, it will
        take effect immediately. You agree that we, in our sole discretion and
        for any or no reason, may terminate/delete your account or any part
        thereof. You agree that any termination of your access to the Pixapup
        app may be without prior notice, and you agree that we will not be
        liable to you or any third party for such termination. After
        termination, you will no longer have access to your data or Content or
        any other information provided to the Pixapup app, and we may delete all
        such information. We accept no liability for such deleted information.
        We have no obligation to provide you a copy of your data or Content,
        except to the extent required by applicable law. The provisions of this
        Agreement relating to limitation of liability, exclusion of warranties,
        indemnification and intellectual property rights shall continue to be
        effective after your account is terminated.
      </p>

      <p>
        Deleting your account results in the removal from the secure Google
        Cloud storage platform and databases we use of any of your identifying
        data attributes, such as your email address.
      </p>
      <p>
        Deleting your account results in the removal from the secure Google
        Cloud storage platform and database of any and all Content you uploaded
        using the Pixapup app.
      </p>
      <p>
        If any of your Content was published in one or more of our custom books,
        calendars, or other works, those published works remain intact on the
        respective selling platforms/websites on which they currently exist, if
        they exist. Further, the data record created and stored when you
        uploaded the Content that was published remains in the secure Google
        Cloud storage platform and databases as a claim to our right to the use
        of the Content under the terms and provisions of this Agreement.
      </p>

      <h3>Disclaimer of Warranties</h3>
      <p>
        YOU EXPRESSLY AGREE THAT YOU ARE WORKING WITH US AT YOUR OWN RISK. WE
        MAKE NO WARRANTY THAT YOUR CONTENT WILL BE UNINTERRUPTED, SECURE OR
        ERROR-FREE. ALL CONTENT, INFORMATION, AND OTHER MATERIAL IS PROVIDED "AS
        IS" AND "AS AVAILABLE". WE MAKE NO ENDORSEMENTS, GUARANTEES,
        REPRESENTATIONS OR WARRANTIES, EXPRESS, IMPLIED OR STATUTORY, WITH
        RESPECT TO THE TIMELINESS, ACCURACY, AUTHORITY, COMPLETENESS,
        USEFULNESS, NON-INFRINGEMENT, RELIABILITY, AVAILABILITY, OR SUBSTANCE OF
        ANY CONTENT, INFORMATION, OR OTHER MATERIAL THAT WE PROVIDE.
      </p>

      <h3>Limitation of Liability</h3>
      <p>
        You agree that we will not be liable for any consequential, indirect,
        special, exemplary, or incidental damages arising out of or in
        connection with your use of or inability to use our services (including,
        without limitation, any damages for lost profits or business
        interruption), or for any claim made against you by any other party,
        whether arising from mistakes, omissions, interruptions, deletion of
        files or e-mails, errors, defects, viruses or other malicious code,
        delays in operation or transmission, or any failure of performance, even
        if we have been advised of the possibility of such damages. You also
        agree that under no circumstances will we be liable in any way for any
        Content or for any loss or damage of any kind incurred as a result of
        the use of any Content submitted, posted, emailed or otherwise made
        available to and through us.
      </p>

      <h3>Submission Rules</h3>
      <p>
        Notice: You may not submit Content if you are under the age of 16. By
        submitting Content to us, you represent that you are age 16 or older.
      </p>
      <p>You agree not to submit Content:</p>

      <ul>
        <li>
          That is unlawful, pornographic, defamatory, libelous, harmful,
          threatening, abusive, harassing, or invasive of another's privacy, or
          harms minors in any way;
        </li>
        <li>
          That harasses, degrades, intimidates or is hateful toward an
          individual or group of individuals on the basis of religion, gender,
          sexual orientation, race, ethnicity, age, or disability;
        </li>
        <li>
          That falsely claims to be submitted by another person or entity, or
          falsely states or otherwise misrepresents your affiliation with
          another person or entity;
        </li>
        <li>
          That includes personal or identifying information about another
          person, or uses the name or likeness of another person for commercial
          purposes, without that person's explicit consent;
        </li>
        <li>
          That infringes any patent, trademark, trade secret, copyright or other
          proprietary rights of any party, or Content that you do not have a
          right to make available under any law or under contractual or
          fiduciary relationships;
        </li>
        <li>
          That is false, fraudulent, deceptive, misleading, deceitful,
          misinformative or uses "bait-and-switch" tactics;
        </li>
        <li>
          That constitutes or contains "junk mail," "spam," "chain letters,"
          "pyramid schemes," unsolicited commercial advertisement, "affiliate
          marketing," or "link referral code";
        </li>
        <li>
          That constitutes or contains any form of advertising or solicitation;
        </li>
        <li>
          That advertises or features any illegal services or the sale of any
          items the sale of which is prohibited or restricted by applicable law,
          including, without limitation, items the sale of which is prohibited
          or regulated by applicable law;
        </li>
        <li>
          That contains software viruses, worms, trojan horses, or any other
          computer code, files or programs designed to interrupt, destroy or
          limit the functionality of any computer software or hardware or
          telecommunications equipment;
        </li>
        <li>
          That disrupts the operation of our company with an excessive number of
          messages (flooding attack), or that otherwise negatively affects other
          users' ability to work with us; or
        </li>
        <li>
          That employs misleading email addresses, or forged headers or
          otherwise manipulated identifiers in order to disguise the origin of
          Content.
        </li>
      </ul>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'TermsOfServiceModal',
};
</script>

<style>
</style>